import { getAuthToken } from './authSession';

// Eenvoudige "stale-while-revalidate"-cache in het geheugen: schermen tonen de
// laatst opgehaalde gegevens meteen (geen "Laden..." bij elke tabwissel) en
// verversen ze op de achtergrond. Sleutels zijn per ingelogde gebruiker, en de
// cache verdwijnt bij het herstarten van de app/pagina.
const store = new Map();
const scope = () => (getAuthToken() || '').slice(-16);

export const cacheGet = (key) => store.get(`${scope()}|${key}`);
export const cacheSet = (key, value) => { store.set(`${scope()}|${key}`, value); };
export const cacheClear = () => store.clear();
